"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _user = require("@/api/admin/user/user");
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          name: [{
            required: true,
            message: "请输入省份名称",
            trigger: "blur"
          }, {
            min: 2,
            max: 12,
            message: "长度在 2 到 12 个字符",
            trigger: "blur"
          }],
          uniqueCode: [{
            required: true,
            message: "请输入编号",
            trigger: "blur"
          }]
          // startTime: [
          //   { required: true, message: "请选择开通日期", trigger: "blur" },
          // ],
          // endTime: [
          //   { required: true, message: "请选择截止日期", trigger: "blur" },
          // ],
        },
        labelWidth: "220px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "编号：",
          isDisabled: false,
          placeholder: "请输入编号",
          prop: "uniqueCode",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "省份名称：",
          isDisabled: false,
          placeholder: "请输入省份名称",
          prop: "name",
          value: "",
          span: 12
        }, {
          type: "date",
          label: "开通日期：",
          isDisabled: false,
          placeholder: "请输入开通日期",
          prop: "startTime",
          value: "",
          span: 12
        }, {
          type: "date",
          label: "截止日期：",
          isDisabled: false,
          placeholder: "请输入截止日期",
          prop: "endTime",
          value: "",
          span: 12
        }, {
          type: "radio",
          label: "状态：",
          isDisabled: false,
          prop: "state",
          value: "1",
          span: 12,
          options: [{
            name: "正常",
            value: "1",
            isDisabled: true
          }, {
            name: "禁用",
            value: "2",
            isDisabled: false
          }]
        }, {
          type: "radio",
          label: "是否生成默认管理员：",
          isDisabled: false,
          prop: "isSys",
          value: "1",
          span: 12,
          options: [{
            name: "是",
            value: "1",
            isDisabled: true
          }, {
            name: "否",
            value: "2",
            isDisabled: false
          }]
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      e.id = this.$route.query.id;
      (0, _user.provinceEdit)(e).then(function (res) {
        _this.$message.success("操作成功。");
        _this.$router.push("/province/provinceList");
      }).catch(function (e) {
        return e;
      });
    }
  },
  created: function created() {
    this.formData.formItem[0].value = this.$route.query.uniqueCode;
    this.formData.formItem[1].value = this.$route.query.name;
  }
};